import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from "@angular/router";
import { AppComponent } from '../app.component';
import { ContainerComponent } from '../container/container.component';
import { AddProductComponent } from '../admin/add-product/add-product.component';
import { AuthGuard } from '../guards/auth.guard';

const appRoutes: Routes = [
  {
    path: "",
    component: ContainerComponent
  },
  {
    path: "browsing/:id",
    component: ContainerComponent
  },
  {
    path: "admin/add-product",
    component: AddProductComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts